<div class="modal-backdrop fade show"></div>
<div class="modal d-block fm-modal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered fm-modal-dialog" role="document">
    <div class="modal-content fm-modal-content">

      <div class="fm-logout-modal-header">
        <button type="button" class="btn-close fm-logout-close" (click)="close()" aria-label="Close"></button>
      </div>

      <div class="modal-body fm-modal-body fm-logout-modal-body text-center">
        <div class="fm-logout-icon-wrap">
          <i class="bi bi-exclamation-triangle" style="font-size:2rem;color:#dc3545;"></i>
        </div>
        <h5 class="fm-head-20 mt-3 mb-2">{{ title() }}</h5>
        <p [innerHTML]="message()"></p>
        <div class="d-flex gap-3 justify-content-center mt-3">
          <button type="button" class="fm-common-btn fm-btn-outline" (click)="cancel()">{{ cancelButtonText() }}</button>
          <button type="button" class="fm-common-btn fm-btn-danger" (click)="confirmDelete()">{{ confirmButtonText() }}</button>
        </div>
      </div>

    </div>
  </div>
</div>